module.exports = __webpack_public_path__ + "media/images/emblems/Trin_wappen-75803d0b524da28a87e654a632c33d73.svg";